<template>
  <div class="flex flex-col gap-4">
    <slot name="title"></slot>
    <div class="flex justify-between gap-4">
      <div class="flex flex-col items-start">
        <slot name="start" />
      </div>
      <div class="grow flex items-center">
        <div class="w-2.5 h-2.5 rounded-full border"></div>
        <div class="grow bg-neutral-200 h-px mx-1"></div>
        <div class="w-2.5 h-2.5 rounded-full bg-black"></div>
      </div>
      <div class="flex flex-col items-end">
        <slot name="end" />
      </div>
    </div>
  </div>
</template>
